import React from 'react';

import { ExplorerStyles } from '../Explorer/ExplorerStyles';
import { spaceHeaderID } from './SpaceHeaderWithTotalItemsCount';


export function SpaceSubHeaderContent(props: { subheaderText: string; testId?: string;
    headingId?: string; }): JSX.Element {
    return <div className={ExplorerStyles.SpaceHeaderContent}>
        <h2 id={props.headingId ? props.headingId : spaceHeaderID} className={ExplorerStyles.SpaceSubHeaderText}
            data-tb-test-id={props.testId}>{props.subheaderText}</h2>
    </div>;
}

